<template>
  <el-dialog class="detailsDialog" width="1080px" title="还款记录" :visible.sync="form.dialog" :append-to-body="true">
    <div class="commonInfo">
      <div class="content" style="margin: 0 0 10px 0;">
        <h3>姓名：{{ nickName }}</h3>
        <h3>会员卡号：{{ cardNo }}</h3>
        <h3>联系电话：{{ userPhone ? Lib.starPhone(userPhone) : '--' }}</h3>
        <!-- <h3>总赊账：{{ form.totalMoney ? form.totalMoney.toFixed(2) : '0.00' }}元</h3>
        <h3>已还款：{{ form.refundMoney ? form.refundMoney.toFixed(2) : '0.00' }}元</h3>
        <h3>未还款：{{ form.unRefundMoney ? form.unRefundMoney.toFixed(2) : '0.00' }}元</h3> -->
      </div>
    </div>
    <div class="block">
      <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="search">
      </el-date-picker>
      <el-input v-model.trim="inputVal" class="width_200 ml_20" placeholder="请输入订单号进行搜索" @keyup.enter.native="search">
        <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
      </el-input>
    </div>
    <div style="margin-top: 15px;">
      <el-table tooltip-effect="light" :data="recordList">
        <el-table-column prop="createTimeStr" label="还款时间" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="orderCode" label="订单号" width="180" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="money" label="赊账金额（元）" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.money">{{ scope.row.money.toFixed(2) }}</span>
            <span v-else>0.00</span>
          </template>
        </el-table-column>
        <el-table-column prop="payMoney" label="还款金额（元）">
          <template slot-scope="scope">
            <span v-if="scope.row.payMoney">{{ scope.row.payMoney.toFixed(2) }}</span>
            <span v-else>0.00</span>
          </template>
        </el-table-column>
        <el-table-column prop="refundWayName" label="还款方式">
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.refundway == 0">现金</span>
            <span v-else-if="scope.row.refundway == 1">银行卡</span>
            <span v-else-if="scope.row.refundway == 2">会员卡</span>
            <span v-else-if="scope.row.refundway == 3">扫码</span>
            <span v-else-if="scope.row.refundway == 6">个人微信</span>
            <span v-else-if="scope.row.refundway == 7">个人支付宝</span>
            <span v-else-if="scope.row.refundway == 9">微信支付（官方）</span>
            <span v-else-if="scope.row.refundway == 10">支付宝（官方）</span>
            <span v-else-if="scope.row.refundway == 11">微信（通联）</span>
            <span v-else-if="scope.row.refundway == 12">支付宝（通联）</span>
            <span v-else-if="scope.row.refundway == 13">微信（翼支付）</span>
            <span v-else-if="scope.row.refundway == 14">支付宝（翼支付）</span>
            <span v-else-if="scope.row.refundway == 21">赊账还款扣除</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="dutyName" label="操作人员">
          <template slot-scope="scope">
            <span>{{ scope.row.dutyName || '--' }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="dutyName" label="授权人员">
          <template slot-scope="scope">
            <span>{{ scope.row.dutyName || '--' }}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div v-if="recordList.length > 0" class="fn_foot">
        <span>合计</span>
        <samp>{{ billInfo.money }}</samp>
        <samp>{{ billInfo.payMoney }}</samp>
      </div>
    </div>
    <div v-if="recordList.length > 0" class="blockThree">
      <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { getHkRecord, getMemberInfo, getAccountRefundSum } from './api/index';

export default {
  data() {
    return {
      cardNo: '', // 会员卡号
      ctName: '', // 会员卡名称
      nickName: '', // 会员昵称
      userPhone: '', // 联系电话
      inputVal: '', // 搜索值
      date: '',
      pageNum: 1,
      rowCount: 1,
      recordList: [], // 还款记录列表数据
      form: { // 赋值数据
        phone: '',
        totalMoney: '', // 总还款
        refundMoney: '', // 已还款
        unRefundMoney: '', // 未还款
        dialog: false
      },
      // 5.9
      pickerOptions: { // 只能选择今天之前的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      billInfo: {}
    };
  },
  // 监听会员ID的变化
  watch: {
    'form.dialog': function (val) {
      if (val) {
        this.inputVal = '';
        this.pageNum = 1;
        this.getUserInfo();
        this.getListData();
      }
    },
    inputVal() {
      this.search();
    }
  },
  mounted() {
    const vm = this;
    vm.$emit('repayRecord', vm.form);
  },
  methods: {
    // 搜索
    search() {
      const vm = this;
      vm.pageNum = 1;
      vm.getListData();
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getListData();
    },
    // 还款记录列表
    getListData() {
      const vm = this;
      const data = {
        keyWord: vm.inputVal || null,
        phone: vm.form.phone,
        pageNum: vm.pageNum,
        pageSize: 10,
        startDate: vm.date ? vm.date[0] : null,
        endDate: vm.date ? vm.date[1] : null
      };
      const dataTwo = {
        keyWord: vm.inputVal || null,
        phone: vm.form.phone,
        startDate: vm.date ? vm.date[0] : null,
        endDate: vm.date ? vm.date[1] : null
      };
      getHkRecord(data).then((res) => {
        vm.recordList = res.data.records;
        vm.rowCount = res.data.total;
      });
      getAccountRefundSum(dataTwo).then((res) => {
        if (res.code == 0) {
          this.billInfo = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 获取会员信息
    getUserInfo() {
      const vm = this;
      const data = {
        keyWord: vm.form.phone
      };
      getMemberInfo(data).then((res) => {
        vm.cardNo = res.data.cardNo;
        vm.ctName = res.data.ctName;
        vm.nickName = res.data.nickName;
        vm.userPhone = res.data.phone;
      });
    }
  }
};
</script>
